import { createSlice } from '@reduxjs/toolkit';

interface transactionsState {
  transactionsHistory: any;
  otpConfirm: boolean;
  verifyTransId: string;
  orders: any;
  activePanel: any;
  repeatOwnTransaction: any;
  repeatExchangeTransaction: any;
  repeatInternalTransaction: any;
  repeatInterbankTransaction: any;
  repeatSwiftTransaction: any;
  repeatSwiftRubTransaction: any;
  repeatSwiftTjsTransaction: any;
  repeatElectricTransaction: any;
  repeatAsycudaTransaction: any;
  deadline: any;
}

const initialState: transactionsState = {
  transactionsHistory: [],
  otpConfirm: false,
  verifyTransId: '',
  orders: [],
  activePanel: '',
  repeatElectricTransaction: {},
  repeatOwnTransaction: {},
  repeatExchangeTransaction: {},
  repeatInternalTransaction: {},
  repeatInterbankTransaction: {},
  repeatSwiftTransaction: {},
  repeatSwiftTjsTransaction: {},
  repeatSwiftRubTransaction: {},
  repeatAsycudaTransaction: {},
  deadline: 0,
};

const transactions = createSlice({
  name: 'transactions',
  initialState,
  reducers: {
    deadlineAC(state, action) {
      state.deadline = action.payload;
    },
    transactionsHistoryAC(state, action) {
      state.transactionsHistory = [];
      state.transactionsHistory = action.payload;
    },
    otpConfirmAC(state, action) {
      state.otpConfirm = action.payload;
    },
    verifyTransIdAC(state, action) {
      state.verifyTransId = action.payload;
    },
    ordersAC(state, action) {
      state.orders = action.payload;
    },
    activePanelAC(state, action) {
      state.activePanel = action.payload;
    },
    repeatElectricTransactionAC(state, action) {
      state.repeatElectricTransaction = action.payload;
    },
    repeatOwnTransactionAC(state, action) {
      state.repeatOwnTransaction = action.payload;
    },
    repeatExchangeTransactionAC(state, action) {
      state.repeatExchangeTransaction = action.payload;
    },
    repeatInternalTransactionAC(state, action) {
      state.repeatInternalTransaction = action.payload;
    },
    repeatInterbankTransactionAC(state, action) {
      state.repeatInterbankTransaction = action.payload;
    },
    repeatSwiftTransactionAC(state, action) {
      state.repeatSwiftTransaction = action.payload;
    },
    repeatSwiftRubTransactionAC(state, action) {
      state.repeatSwiftRubTransaction = action.payload;
    },
    repeatSwiftTjsTransactionAC(state, action) {
      state.repeatSwiftTjsTransaction = action.payload;
    },
    repeatAsycudaTransactionAC(state, action) {
      state.repeatAsycudaTransaction = action.payload;
    },
  },
});

export const {
  repeatElectricTransactionAC,
  repeatSwiftRubTransactionAC,
  repeatSwiftTjsTransactionAC,
  repeatSwiftTransactionAC,
  transactionsHistoryAC,
  otpConfirmAC,
  verifyTransIdAC,
  ordersAC,
  activePanelAC,
  repeatOwnTransactionAC,
  repeatInternalTransactionAC,
  repeatInterbankTransactionAC,
  deadlineAC,
  repeatExchangeTransactionAC,
  repeatAsycudaTransactionAC,
} = transactions.actions;

export default transactions.reducer;
